import type {
  StorefrontTagListRequestType,
  StorefrontTagListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontTagList = <TData = StorefrontTagListResponseType,>(
  params: StorefrontTagListRequestType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontTags, params],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `storefront-tags`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
